import { useTranslation } from "@opendash/i18n";
import { Select } from "antd";
import { DefaultOptionType } from "antd/lib/select";
import { observer } from "mobx-react-lite";
import { Role, User } from "parse";
import React, { useMemo } from "react";
import { getUsername } from "../../../../../../_shared";
import { _Role, _User } from "../../../../../../js/parsegenerated";

type Props = {
  users: User[];
  roles: Role[];

  value?: Array<{
    type: "user" | "role";
    id: string;
  }>;

  onChange?: (
    value: Array<{
      type: "user" | "role";
      id: string;
    }>
  ) => void;
};

export const AssignmentSelect = observer((props: Props) => {
  const t = useTranslation();
  const options: DefaultOptionType[] = useMemo(() => {
    const userData = {
      label: t("maintenance:ticket.create.assignment.users"),
      title: t("maintenance:ticket.create.assignment.users"),
      options: props.users.map(
        (user: _User) =>
          ({
            title: user.id,
            value: "user_" + user.id,
            key: "user_" + user.id,
            label: getUsername(user),
          }) as DefaultOptionType
      ),
    };
    const roleData = {
      label: t("maintenance:ticket.create.assignment.roles"),
      title: t("maintenance:ticket.create.assignment.roles"),
      options: props.roles.map(
        (role: _Role) =>
          ({
            title: role.get("name"),
            value: "role_" + role.id,
            key: "role_" + role.id,
            label: role.get("label"),
          }) as DefaultOptionType
      ),
    };
    return [userData, roleData];
  }, [props.users, props.roles]);

  return (
    <Select
      mode="multiple"
      allowClear
      options={options}
      showSearch
      size="small"
      optionFilterProp="title"
      placeholder={t("maintenance:ticket.create.assignment.placeholder")}
      style={{ maxWidth: 200, width: 200, height: 24 }}
      maxTagCount="responsive"
      onChange={(value) => {
        const parsedValue = value.map((v) => {
          const [type, id] = v.split("_");
          return { type: type as "user" | "role", id };
        });
        props.onChange?.(parsedValue);
      }}
      value={props.value?.map((v) => v.type + "_" + v.id) ?? []}
    />
  );
});
